export default __webpack_public_path__ + "static/media/speedometer.cd236d16.gif";